import { useLingui } from "@lingui/react"
import { Check, ChevronDown } from "lucide-react"
import { useFetcher } from "react-router"
import { Button } from "~/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "~/components/ui/dropdown-menu"
import { Typography } from "~/components/ui/typography"
import {
  type SupportedLocaleCode,
  allLocales,
  allLocalesKeys,
} from "~/utils/supported-locales"

export const LanguageSwitcher = () => {
  const { i18n } = useLingui()
  const fetcher = useFetcher()
  const locales = allLocales()
  const current = locales[i18n.locale as SupportedLocaleCode] ?? locales.en

  const onSelect = (code: SupportedLocaleCode) => {
    fetcher.submit(
      { locale: code },
      { method: "POST", action: "/api/set-locale" },
    )
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="gap-2 font-medium">
          <img
            src={current.flagUrl}
            alt=""
            className="size-6 rounded-full object-cover"
          />

          <Typography variant="small" className="uppercase tracking-wide">
            {current.code}
          </Typography>

          <ChevronDown className="size-4 text-muted-foreground" />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-44">
        {allLocalesKeys().map(code => {
          const lang = locales[code]
          return (
            <DropdownMenuItem
              key={lang.code}
              onClick={() => onSelect(lang.code)}
              className="gap-2"
            >
              <img
                src={lang.flagUrl}
                alt=""
                className="size-6 rounded-full object-cover"
              />

              <Typography className="flex-1">{lang.native}</Typography>

              {current.code === lang.code && <Check className="size-4" />}
            </DropdownMenuItem>
          )
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
